import React from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom';

import './NavBarImportacao.css'

import ImportExportIcon from '@mui/icons-material/ImportExport';
import MenuIcon from '@mui/icons-material/Menu';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import FeedIcon from '@mui/icons-material/Feed';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';


const NavBarImportacao = ( {dadosUsuarios, setDadosUsuarios}) => {
    const [menuOpen, setMenuOpen] = useState(false)


    function handleSair() {
        localStorage.removeItem("usuario")
        setDadosUsuarios(null)
    }

    function verificarUsuario() {
      if(dadosUsuarios){
        const now = Date.now(); 
        if(Math.floor((now-dadosUsuarios.lastLoginAt)/(1000 * 60 * 60 * 24)) > 5)
          handleSair()
      }
    }

    function diferencaEmDias(data1, data2) {
    // Criar objetos Date (se já não forem)
    const d1 = new Date(data1);
    const d2 = new Date(data2);
    
    // Diferença em milissegundos
    const diffTime = Math.abs(d2 - d1);
    
    // Converter para dias
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    return diffDays;
}

verificarUsuario()

  return (
      <div>
          <div className={`sidebar ${menuOpen? "aberto" : ""}`}>
              <div className="top">
                  <div className="logo">
                    <ImportExportIcon/>
                    <span>Área do Cliente</span>
                  </div>
                  <MenuIcon onClick={()=>setMenuOpen(!menuOpen) } id="btn" />
              </div>
              <div className="user">
                  {dadosUsuarios && <>
                      <img src={dadosUsuarios.photoURL} alt="foto usuario" className='userimg' />
                    <div className="bold">
                      <p>{dadosUsuarios.displayName}</p>
                      <p>{dadosUsuarios.email}</p>
                      </div>
                  </>}
              </div>
              <ul>
                  <li>
                    <Link to="xmlnfe">
                        <NewspaperIcon/> <span className="navitem">Importar NFe</span>
                      </Link>
                      <span className="tooltip">Importar NFe</span>
                  </li>
                  <li>
                    <Link to="xmlcfe">
                        <ReceiptIcon/> <span className="navitem">Importar CFe</span>
                      </Link>
                      <span className="tooltip">Importar CFe</span>
                  </li>
                  {dadosUsuarios && 
                  (dadosUsuarios.email === "contatolucianocastro@gmail.com" || 
                  dadosUsuarios.email ===  "assiscastro@castroeamaral.com.br"|| 
                  dadosUsuarios.email ===  "leo.kasfer@gmail.com"|| 
                  dadosUsuarios.email ===  "manoelcleon@gmail.com"|| 
                  dadosUsuarios.email ===  "ofacilitadorfiscalecontabil@gmail.com"|| 
                  dadosUsuarios.email ===  "setorcontabil@castroeamaral.com.br") && <>
                  <li>
                    <Link to="txtsped">
                        <FeedIcon/> <span className="navitem">Importar Sped</span>
                      </Link>
                      <span className="tooltip">Importar Sped TXT</span>
                  </li>
                  <li>
                    <Link to="xmlsped">
                        <ReceiptLongIcon/> <span className="navitem">Importar Sped</span>
                      </Link>
                      <span className="tooltip">Importar Sped XML</span>
                  </li>
                  <li>
                    <Link to="conciliarfts">
                        <FindInPageIcon/> <span className="navitem">Conciliar Fortes</span>
                      </Link>
                      <span className="tooltip">Conciliar Fortes</span>
                  </li>
                  <li>
                    <Link to="pagamentos">
                        <RequestQuoteIcon/> <span className="navitem">Importar Pagamentos</span>
                      </Link>
                      <span className="tooltip">Importar Pagamentos</span>
                  </li>
                  </>}
              </ul>
              <div className="bottom" onClick={handleSair}>
                <ExitToAppIcon id="sair" />
                  <span className="textosair">Sair</span>
                  <span className="tooltip">Sair</span>
              </div>
          </div>
    </div>
  )
}

export default NavBarImportacao